import { post, get } from './axios'
const { refreshWechatAppSessionQuery, referralUserQuery } = require('./query')

export const refreshWechatAppSession = (data = {}) => post('/api/graphql/', Object.assign(data, refreshWechatAppSessionQuery()))
export const referralUser = (data = {}) => post('/api/graphql/', Object.assign(data, referralUserQuery()))

export const getWxConfig = (data = {}) => get('/api/services/wechat/jssdk_config', data)

